module.exports = "/_next/static/images/icon-logout-45c4c247.png";